import * as apiUtils from "./apiUtils";
const baseUrl = process.env.API_URL + "/Vehicles/";

//`${baseUrl}GetServices?LocationID=${locationID}&deviceType=${deviceType}`
export function getVehicle(ClientId, UserID, StateOfConviction) {
  return apiUtils
    .get(
      `${baseUrl}GetClientVehicles?ClientID=${ClientId}&UserID=${UserID}&StateOfConviction=${StateOfConviction}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function makeVehicles() {
  return apiUtils
    .get(`${baseUrl}Make`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getVehicleData(LPState, LPNumber, country) {
  return apiUtils
    .post(
      `${baseUrl}GetCarsXEData?LPNumber=${LPNumber}&LPState=${LPState}&country${country}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function updateVehicle(id, params) {
  return apiUtils
    .put(`${baseUrl}UpdateClientVehicle`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function addVehicle(params) {
  return apiUtils
    .post(`${baseUrl}`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getVehicleModels(VehicleMakeId) {
  return apiUtils
    .get(`${baseUrl}GetModel/${VehicleMakeId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
